import { motion } from "framer-motion";
import { AlertTriangle, Zap } from "lucide-react";

export const LowCreditsBar = ({ credits, onNavigate }) => {
  if (credits === undefined || credits === null || credits >= 3) return null;
  const isZero = credits <= 0;
  return (
    <motion.div
      data-testid="low-credits-bar"
      initial={{ y: -10, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      className={`flex items-center justify-between px-4 py-2 text-xs ${
        isZero ? "bg-red-500/10 border-b border-red-500/20" : "bg-gold/10 border-b border-gold/20"
      }`}
    >
      <div className="flex items-center gap-2">
        {isZero ? <AlertTriangle className="w-3.5 h-3.5 text-red-400" /> : <Zap className="w-3.5 h-3.5 text-gold" />}
        <span className={isZero ? "text-red-300" : "text-gold"}>
          {isZero ? "No credits remaining" : `Only ${credits} credit${credits !== 1 ? 's' : ''} left`}
        </span>
      </div>
      <button 
        data-testid="low-credits-buy"
        onClick={() => onNavigate("/pricing")}
        className={`px-3 py-1 rounded-full font-semibold transition-all ${
          isZero ? "bg-red-500 hover:bg-red-400 text-white" : "bg-[#D4AF37] hover:bg-[#D4AF37]/80 text-black"
        }`}
      >
        {isZero ? "Get 30 Credits for $29.99" : "Buy Credits"}
      </button>
    </motion.div>
  );
};
